import React from "react";
import Tile from "@src/components/containers/Tile";
import { SimpleTable } from "@swordsweeper/ssi-ui-component-library";
import { Product } from "@src/types/product";
import DistributorLogo from "@src/components/common/DistributorLogo";
import ProductImage from "@src/components/widgets/ProductImage";
import ProductDescription from "@src/components/widgets/ProductDescription";

interface BackorderedProduct {
  product: Product;
  shipsIn: string;
  distributorSlug: string;
}

interface BackorderedProductsTileProps {
  backorderedProducts: BackorderedProduct[];
  includeDistributorImage: boolean;
}

export default function BackorderedProductsTile({
  backorderedProducts,
  includeDistributorImage,
}: BackorderedProductsTileProps) {
  const columns = [
    {
      key: "rewardImageSrc",
      render: ({ product }: BackorderedProduct) =>
        product.thumbnailUrl ? (
          <ProductImage imageSrc={product.thumbnailUrl} sizePx={30} />
        ) : null,
    },
    {
      key: "product",
      render: ({ product }: BackorderedProduct) => (
        <div className="text-xs text-secondary">
          <div>{product.itemName}</div>
          <ProductDescription
            description={product.description}
            maxWidth="40vw"
          />
        </div>
      ),
    },
    {
      key: "shipsIn",
      render: ({ shipsIn }: BackorderedProduct) => (
        <span className="text-xs text-secondary width-100 text-right">
          Ships in {shipsIn}
        </span>
      ),
    },
  ];

  if (includeDistributorImage) {
    columns.push({
      key: "distributor",
      render: ({ distributorSlug }: BackorderedProduct) => (
        <div className="width-100 text-right">
          <DistributorLogo distributorSlug={distributorSlug} />
        </div>
      ),
    });
  }

  return (
    <Tile>
      <div className="font-weight-bold padding-bottom-xs border-bottom">
        On Backorder
      </div>

      <SimpleTable
        className="table-no-headers table-no-row-borders"
        hideTopBorder
        columns={columns}
        data={backorderedProducts}
      />
    </Tile>
  );
}
